<template>
  <div>
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid" :disabled="readonly">

      <RessourceInfoBulle code="APRP-SC-1" />
      <RessourceInfoBulle code="APRP-SC-2" />

      <fieldset>
        <legend class="text-h6 text-sm-h5">
            Scolarité
          </legend>
          <div>
            <div class="mb-10" v-for="(type, index) in getScolariteType" :key="index">
              <v-text-field
                v-model="type.lang00"
                filled
                dense
                single-line
                hide-details
                readonly
                required
                background-color="white"
                :rules=rules.TablesNotEmpty(type)
                class="centered-input"
                style="border: 1px solid #ccc;"
              ></v-text-field>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 10%">Sigle</th>
                      <th>Nom du cours</th>
                      <th style="width: 50%">Description du cours et du lien avec la réalisation de l'activité réservées</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in getScolaritesForType(type.id)" :key="index">
                      <td>
                        <v-text-field
                            v-model="item.sigle"
                            :rules="rules.ChampsRempli"
                            class="cssRequired"
                            label="Sigle"
                            required
                          ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                            v-model="item.nomDuCours"
                            :rules="rules.ChampsRempli"
                            class="cssRequired"
                            label="Nom du cours"
                            required
                          ></v-text-field>
                      </td>
                      <td>
                        <v-textarea 
                          v-model="item.descriptionBloc"
                          clear-icon="mdi-close-circle"
                          clearable
                          outlined
                          rows="1"
                          class="pt-6"
                          label="Description du cours et du lien avec la réalisation de l'activité réservées"
                          ></v-textarea>
                      </td>
                      <td class="text-right">
                        <v-icon
                          v-bind:class="{
                            'clickable redIcon':
                              item.demandeAdmission === demandeAdmissionId,
                            'standardPointer greyIcon':
                              item.demandeAdmission !== demandeAdmissionId,
                          }"
                          @click="deleteRow(item)"
                          >mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div class="text-center mt-6 d-flex justify-lg-flex-end">
                <v-btn color="primary" @click="ajouter(type)">ajouter</v-btn>
              </div>
            </div>
          </div>
      </fieldset>

      <div>
        <v-row>
            <v-col class="legalSection">
              <Attachment
                ref="equivPlanCoursPrp"
                file-prefix="form_equiv_plan_cours_prp"
                @completeEvent="saveNextAttachment"
                @refreshEvent="validateForm(true)"
              ></Attachment>
            </v-col>
          </v-row>
      </div>

    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="secondary" @click="saveAndContinueLater()">Enregistrer et terminer plus tard</v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Attachment from "../attachments/Attachment"
import Loader from "../Loader"
import NavigationPageFormulaireMixin from "@/mixins/navigationPageFormulaireMixin"
import PageReadonlyFormulaireAdmissionMixin from "@/mixins/pageReadonlyFormulaireAdmissionMixin"
import AttachementFormulaireMixin from "@/mixins/attachementFormulaireMixin"

export default {
  mixins: [
    NavigationPageFormulaireMixin,
    PageReadonlyFormulaireAdmissionMixin,
    AttachementFormulaireMixin,
  ],
  props: {
    routeName: {
      type: String,
      default: ''
    },
  },
  components: {
    Attachment: Attachment,
    Loader: Loader
  },
  data () {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      rules: {
        ChampsRempli: [
          (v) => (!!v && v.length != 0) || "Le champs ne peut être vide",
        ],
        TablesNotEmpty: (type) => [val => this.IsTablesNotEmpty(type) || `Au moins un élément est requis`],
      },
    }
  },
  computed: {
    ...mapGetters({
      demandeAdmissionId: "DemandeAdmission/GET_DEMANDEADMISSIONID",
      demandeAdmissionPpId: "DemandeAdmission/GET_CONTACTID",
      contactId: "DemandeAdmission/GET_CONTACTID",
      getScolarites: "Scolarite/GET_SCOLARITES",
      getAllScolarites: "Scolarite/GET_ALL_SCOLARITES",
      getScolariteType: "Catalogue/getScolariteType",
    }),
  },
  created () {
    this.fetchItems()
  },
  methods: {
    ...mapMutations({
      addScolarite: "Scolarite/ADD_SCOLARITE",
      removeScolarite: "Scolarite/REMOVE_SCOLARITE",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getDocumentsByContactId: "Documents/getDocumentsByContactId",
      getScolaritesByDemandeAdmissionId: "Scolarite/getScolaritesByDemandeAdmissionId",
      deleteScolarite: "Scolarite/deleteScolarite",
      createScolarite: "Scolarite/createScolarite",
      updateScolarite: "Scolarite/updateScolarite",
    }),
    async fetchItems () {
      try {
        this.messageSelector = "Loading";
        this.overlay = true;

        if (this.demandeAdmissionId) {
          await this.getScolaritesByDemandeAdmissionId(this.demandeAdmissionId);
        }

        if (this.demandeAdmissionPpId  && this.demandeAdmissionPpId !== "") {
          await this.getDocumentsByContactId(this.demandeAdmissionPpId);
        }

        // Catalogue Scolarite type
        this.getCatalogue(this.$cataloguesDesc.scolariteType);

        // Liste les uploads de fichiers
        this.refsUpload = [
          () => this.$refs.equivNotes,
          () => this.$refs.equivPlanCoursPrp,
        ];

        this.overlay = false;
      } catch (erreur) {
        console.log(erreur);
      }
    },
    save () {
      this.validateForm()
      if (this.valid) {
        this.messageSelector = "Save"
        this.overlay = true

        if (this.getAllScolarites) {
          this.getAllScolarites.forEach((element, index, array) => {
            if (this.demandeAdmissionId) {
              element.demandeAdmission = this.demandeAdmissionId;
            }
            if (element.id == null) {
              this.createScolarite(element);
            } else {
              if (element.deleted === true) {
                this.deleteScolarite(element.id);
              } else {
                this.updateScolarite(element);
              }
            }
          });
          
          this.saveAttachments(
            "demandeAdmission",
            this.demandeAdmissionId,
            () => {
              this.overlay = false;
              this.redirect();
          })
        }
      }
    },
    ajouter(typeScolarite) {
      if (this.getScolarites) {
        this.addScolarite({
          id: null,
          pp: this.demandeAdmissionPpId,
          demandeAdmission: this.demandeAdmissionId,
          typeScolarite: typeScolarite,
        });
      }
    },
    deleteRow(item) {
      if (item.demandeAdmission === this.demandeAdmissionId) {
        this.removeScolarite(item);
      }
    },
    validateForm(resetValidation = false) {
      this.valid = (this.$refs.form?.validate() || false);

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    getScolaritesForType(type) {
      return this.getScolarites.filter(scolarite => scolarite.typeScolarite.id == type);
    },
    IsTablesNotEmpty: function (scolariteType) {
      return this.getScolarites.some(scolarite => scolarite.typeScolarite.id == scolariteType.id)
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center;
}
</style>